import React, { useState } from "react";
import { FaUser, FaLock, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const data = { username, password, role };

    try {
      const res = await fetch(`${BASE_URL}/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await res.json();

      if (!res.ok) {
        setError(result.detail || res.statusText);
        return;
      }

      setSuccess("✅ User created successfully!");
      setUsername("");
      setPassword("");
      setRole("");
    } catch (err) {
      console.error("Signup error:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 relative">
      {/* 🔙 Back Button */}
      <button
        onClick={() => navigate(-1)} // go back to previous page
        className="absolute top-6 left-6 flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-gray-200 px-4 py-2 rounded-lg shadow-md transition-all duration-300"
      >
        <FaArrowLeft />
        <span>Back to Dashboard</span>
      </button>

      <div className="w-full max-w-md bg-gray-800 p-8 rounded-2xl shadow-2xl border border-gray-700">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-white">Create New User</h2>
          <p className="text-gray-400 mt-1">Admin access only</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username */}
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Username
            </label>
            <div className="flex items-center px-3 bg-gray-700 rounded-md">
              <FaUser className="text-gray-400 mr-2" />
              <input
                type="text"
                id="username"
                placeholder="Enter username"
                className="w-full py-2 bg-transparent text-gray-100 focus:outline-none"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Password
            </label>
            <div className="flex items-center px-3 bg-gray-700 rounded-md">
              <FaLock className="text-gray-400 mr-2" />
              <input
                type="password"
                id="password"
                placeholder="Enter password"
                className="w-full py-2 bg-transparent text-gray-100 focus:outline-none"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Role */}
          <div>
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Select Role
            </label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="w-full px-3 py-2 bg-gray-700 text-gray-100 rounded-md focus:outline-none"
              required
            >
              <option value="" disabled>
                Choose role
              </option>
              <option value="admin">Admin</option>
              <option value="developer">Developer</option>
            </select>
          </div>

          {/* Error / Success Messages */}
          {error && (
            <p className="text-red-500 text-sm text-center font-medium">
              {error}
            </p>
          )}
          {success && (
            <p className="text-green-500 text-sm text-center font-medium">
              {success}
            </p>
          )}

          {/* Submit */}
          <button
            type="submit"
            className="w-full py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold transition duration-300"
          >
            Create User
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
